// extracted by mini-css-extract-plugin
export default {"wrap":"Mt-z","fullWidth":"Nt-z","items":"Ot-z","featureCss":"Pt-z","disabled":"Qt-z","imgCss":"Rt-z"};